module.exports = __webpack_public_path__ + "static/assets/79a34e467527cb738e61522784526e81.svg";